import { createFileRoute, notFound } from '@tanstack/react-router'
import { NotFoundPage } from '@/components/errors/NotFoundPage'

export const Route = createFileRoute('/{-$locale}/404')({
  beforeLoad: () => {
    throw notFound()
  },
  component: NotFoundPage,
})
